import { PriceUtils, ServiceProposalFee } from "@repo/common"
import * as React from "react"
import {
  SelectableCard,
  SelectableCardContent,
  SelectableCardDescription,
  SelectableCardHeader,
  SelectableCardLabel,
} from "./selectable-card"

interface ServiceProposalFeeCardProps {
  data: ServiceProposalFee
  className?: string
}

const ServiceProposalFeeCard = React.forwardRef<
  HTMLDivElement,
  ServiceProposalFeeCardProps
>(({ className, data }, ref) => {
  return (
    <SelectableCard
      ref={ref}
      className={className}
      selected={false}
      interactive={false}
      color="secondary"
    >
      <SelectableCardHeader className="justify-between">
        <SelectableCardLabel>{data.title}</SelectableCardLabel>
        <SelectableCardDescription>
          {PriceUtils.format(data.cost)}
        </SelectableCardDescription>
      </SelectableCardHeader>

      {data.description && (
        <SelectableCardContent>
          <SelectableCardDescription>
            {data.description}
          </SelectableCardDescription>
        </SelectableCardContent>
      )}
    </SelectableCard>
  )
})

ServiceProposalFeeCard.displayName = "ServiceProposalFeeCard"

export { ServiceProposalFeeCard, type ServiceProposalFeeCardProps }
